import React from 'react';
import { MdDelete, MdEdit, MdShare } from 'react-icons/md';

import { Link } from 'react-router-dom';
import { IDashboard } from './utils/utils';

type DashboardItemProps = {
  dashboard: IDashboard;
  onShare: (dashboard: IDashboard) => void;
  onDelete: (dashboard: IDashboard) => void;
  loggedInUser: string;
};

export const DashboardItem = (props: DashboardItemProps): JSX.Element => {
  const { dashboard } = props;

  return (
    <div className="dashboard-item">
      <div className="dashboard-item_header">
        <Link to={{ pathname: `dashboard/${dashboard.id}` }} title={dashboard.name} className="dashboard-item_title">
          {dashboard.name}
        </Link>
        <div className="dashboard-item_tools">
          <>
            <MdDelete
              className="float-right dashboard-icon"
              onClick={() => {
                props.onDelete(dashboard);
              }}
              size={20}
              title={'delete'}
            />
            <Link to={{ pathname: `/dashboard/${dashboard.id}/edit` }}>
              <MdEdit className="float-right dashboard-icon" title={'edit'} />
            </Link>
          </>
        </div>
      </div>
      <div className="dashboard-item_info">
        <span>{dashboard.widgets && dashboard.widgets.length > 0 ? dashboard.widgets.length : 0} Widget(s) Added</span>
        {/* <div className="dashboard-item_ellipsis">
          <Ellipsis className="float-right" />
          </div> */}
      </div>
      <Link to={{ pathname: `dashboard/${dashboard.id}` }}>
        <div className="dashboard-item_image">
          <img src={`data:image/png;base64, ${dashboard.image}`}></img>
        </div>
      </Link>
    </div>
  );
};

export default DashboardItem;
